// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginaInicial_container__3CUQi","opciones":"PaginaInicial_opciones__MQ8pq","nombre":"PaginaInicial_nombre__28y9f","iniciar":"PaginaInicial_iniciar__3fkht"};